import { render, staticRenderFns } from "./CreditGBPrime.vue?vue&type=template&id=adbddad0&scoped=true&"
import script from "./CreditGBPrime.vue?vue&type=script&lang=js&"
export * from "./CreditGBPrime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbddad0",
  null
  
)

export default component.exports